__turbopack_context__.v({
  "item": "CilQIW_item",
  "itemInner": "CilQIW_itemInner",
});
